import React from 'react';
import styled from 'styled-components';

const HelpDialogTraning2 = (props) => {
    return(
        <React.Fragment>
            ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝<br />
            <b>☆トレーニングガイドは<a href="https://englishcompany-mobile.jp/guide/" target="_blank" rel="noopener noreferrer">こちら</a>☆</b>
            ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝<br />

            <h2>STEP1. 英単語の意味と発音を確認する</h2>

            「英語をまとめて再生する」をタップし、音声に続いて発音しながら日本語を見て意味を確認しましょう。<br />
            
            <h3>ポイント</h3>
            <Texts><Text>✓ </Text><Text>使う場面をイメージする、動作をするなど、五感をフル活用すると覚えやすくなる</Text></Texts>
            <br />

            <h2>STEP2. 発音と意味を覚える</h2>

            「テストする」をタップします。音声をまねしてリピートしながら英単語の意味を思い浮かべましょう。すべての英単語の意味がパッと思い浮かぶようになるまで、リスト全体を3回ほど繰り返します。<br />
            
            <h3>ポイント</h3>
            <Texts><Text>✓ </Text><Text>英語は必ず発音する</Text></Texts>
            <Texts><Text>✓ </Text><Text>リスト全体を繰り返す際は、覚えたものも飛ばさずすべての英単語を繰り返す</Text></Texts>
            <br />
            
            <h2>STEP3. 英語を覚える</h2>

            英語をOFFにして日本語だけを表示させます。日本語を見て、英語を思い出して発音したのち、英語をONにして合っているかどうか確認しましょう。すべての英単語が瞬時に出てくるようになるまで、リスト全体を3～5回繰り返します。

            <h3>ポイント</h3>
            <Texts><Text>✓ </Text><Text>英語は必ず発音する</Text></Texts>
            <Texts><Text>✓ </Text><Text>英語が瞬時に出てこないときは、すぐに英語をONにして確認</Text></Texts>
            <Texts><Text>✓ </Text><Text>リスト全体を繰り返す際は、覚えたものも飛ばさずすべての英単語を繰り返す</Text></Texts>
        </React.Fragment>
    );
}

export { HelpDialogTraning2 };

const Texts = styled.span`
    display: flex;
`;

const Text = styled.span`
    margin: 0;
`;